import isUndefined from 'lodash/isUndefined';

import store from '../app/store';
import { showNormalNotification } from '../redux/actions/notificationsActions';

export const showNormalMessage = params => {
  if (!isUndefined(params)) {
    return store.dispatch(showNormalNotification({ ...params }));
  }
};



// WEBPACK FOOTER //
// ./src/helpers/messages.js